import { FC } from "react";
import { useDispatch } from "react-redux";

import { CardSwitchCompetitorsWrapperProps } from "./types";
import CardSkeleton from "../CardSkeleton/CardSkeleton";
import CardSwitch from "../CardSwitch/CardSwitch";
import DataLoadError from "../DataLoadError";
import { changeCompetitorStatus, deleteCompetitor } from "../../store/brands/slice";

const CardSwitchCompetitorsWrapper: FC<CardSwitchCompetitorsWrapperProps> = ({
  competitors,
  active = true,
  skeletonCount = 1,
  loading,
  error,
  onRetry,
}) => {
  const dispatch = useDispatch();

  const handleSwitchChange = (id: number, status: boolean) => {
    dispatch(changeCompetitorStatus({ id, isActive: status }));
  };

  const handleDelete = (id: number) => {
    dispatch(deleteCompetitor({ id }));
  };

  const renderSkeletons = () => {
    return Array.from({ length: skeletonCount }).map((_, index) => (
      <CardSkeleton key={index} />
    ));
  };

  if (loading) return renderSkeletons();

  if (!competitors && error) {
    return (
      <DataLoadError
        message={error}
        onRetry={onRetry}
      />
    );
  }

  if (!competitors) return renderSkeletons();

  return (
    <div>{ competitors.map((competitor) => (
      <CardSwitch
          key={competitor.id}
          id={competitor.id}
          title={competitor.name}
          logoUrl={competitor.logoUrl ?? undefined}
          onSwitchChange={handleSwitchChange}
          active={active}
          onDelete={handleDelete} />
    )) }</div>
  );
};

export default CardSwitchCompetitorsWrapper;